import React, { useMemo } from 'react';
import {
    MultipleTicketTypesInformation,
} from '../../MultipleTicketTypesInformation';
import { TicketsSelect } from './package-tickets-select';

import { TicketTypesList } from './TicketTypesList';

export function PackageTickets(props) {
    const hasTicketTypes = props.package.tickets[0].type != null;

    const tickets = useMemo(() => {
        if (props.selectedPackage.ticket.type === null) {
            return props.package.tickets;
        }

        let tickets = [];
        if (props.selectedTicketType !== null) {
            for (let i = 0; i < props.package.tickets.length; i++) {
                let ticket = props.package.tickets[i];

                if (ticket.type === props.selectedTicketType) {
                    tickets.push(ticket);
                }
            }
        }

        return tickets;
    }, [props.selectedPackage, props.selectedTicketType, props.package]);

    return (
        <div className="package__tickets basis-full">
            {hasTicketTypes && <MultipleTicketTypesInformation />}
            {props.ticketTypes.length > 1 && (
                <TicketTypesList
                    ticketTypes={props.ticketTypes}
                    addedTickets={props.addedTickets}
                    selectedTicketType={props.selectedTicketType}
                    disabled={props.confirmedTickets.length > 0}
                    onSelectTicketType={props.onSelectTicketType}
                />
            )}
            <div className="tickets" data-cy="tickets">
                <TicketsSelect
                    confirmedTickets={props.confirmedTickets}
                    selectedTicket={props.selectedTicket}
                    ticketTypes={props.ticketTypes}
                    onSelectTicket={props.onSelectTicket}
                    package={props.package}
                    tickets={tickets}
                    selectedPackage={props.selectedPackage}
                    confirmedPackage={props.confirmedPackage}
                    addedTickets={props.addedTickets}
                    stepTicketDone={props.stepTicketDone}
                    shouldShowAddMoreTicketsButton={props.shouldShowAddMoreTicketsButton}
                    special={props.special}
                    onAddTicket={props.addTicket}
                    onRemoveTicket={props.removeTicket}
                    onConfirmTickets={props.onConfirmTickets}
                    onDeselectPackage={props.onDeselectPackage}
                />
            </div>
        </div>
    );
}
